import { LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import api from '../../service/api';
import useGoalsStore from '../../store/goals';
import useUserStore from '../../store/user';
import LanguageSwitcher from '../LanguageSwitcher';
import NotificationBell from '../NotificationBell';

interface UserPageHeaderProps {
  /** Whether to show the language switcher (defaults to false) */
  showLanguageSwitcher?: boolean;
}

/**
 * Shared header component for all managed (non-manager) user pages.
 * Displays greeting, notification bell, language switcher (optional), and logout button.
 */
export default function UserPageHeader({
  showLanguageSwitcher = false,
}: UserPageHeaderProps) {
  const { t } = useTranslation();
  const user = useUserStore(state => state.user);
  const clearUser = useUserStore(state => state.clearUser);
  const clearGoals = useGoalsStore(state => state.clearGoals);

  const logout = async () => {
    api.sessionDestroy();
    clearUser();
    clearGoals();
  };

  return (
    <h1 className="display-4 fw-black d-flex align-items-center justify-content-between mb-4">
      <span>{t('common.hello', { name: user?.given_name })}</span>
      <div className="d-flex align-items-center gap-3">
        <NotificationBell />
        {showLanguageSwitcher && <LanguageSwitcher />}
        <LogOut
          size={40}
          color="white"
          onClick={logout}
          aria-label={t('common.logout')}
        />
      </div>
    </h1>
  );
}
